import React, { useEffect, useMemo } from "react";
import { X } from "lucide-react";
import { formatSize } from "./constants";
import { extOf, kindOf } from "./fileKinds";
import { tint } from "./format";

/** Files picked in the composer but not sent yet: thumbnail / icon chips with a remove button. */
const PendingFiles = ({ files, onRemove, disabled }) => {
  const previews = useMemo(
    () => files.map((f) => (f.type.startsWith("image/") ? URL.createObjectURL(f) : null)),
    [files],
  );
  useEffect(() => () => previews.forEach((u) => u && URL.revokeObjectURL(u)), [previews]);
  if (!files.length) return null;

  return (
    <div className="er-pending">
      {files.map((f, i) => {
        const kind = kindOf(f.name);
        const Icon = kind.icon;
        return (
          <div key={`${f.name}-${f.size}-${i}`} className="er-pchip" title={f.name}>
            {previews[i] ? (
              <img src={previews[i]} alt="" />
            ) : (
              <span className="er-pico" style={{ background: tint(kind.color, 16), color: kind.color }}><Icon size={16} strokeWidth={1.8} /></span>
            )}
            <span style={{ minWidth: 0 }}>
              <span className="er-ellipsis" style={{ display: "block", fontSize: 12, fontWeight: 600, maxWidth: 120 }}>{f.name}</span>
              <span style={{ fontSize: 10.5, color: "var(--faint)" }}>{extOf(f.name).toUpperCase() || "FILE"} · {formatSize(f.size)}</span>
            </span>
            <button type="button" className="er-btn er-px" aria-label={`Remove ${f.name}`} disabled={disabled} onClick={() => onRemove(i)}><X size={12} strokeWidth={2.4} /></button>
          </div>
        );
      })}
    </div>
  );
};

export default PendingFiles;
